module.exports = __webpack_public_path__ + "img/pan7.ba3edd57.png";